import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
    FaPhoneAlt,
    FaEnvelope,
} from "react-icons/fa";
import { testUrl, universities } from "../home/BaseData";
import { useTranslation } from "react-i18next";
import classes from "./Management.module.css";
import Rektor from "./Rektor.png"; // Default image for empty or missing image

const Rahbariyat = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [leadersData, setLeadersData] = useState([]);// State to hold API data
    const page_id_test = 1;

    useEffect(() => {
        // Fetch data from API
        axios
            .get(testUrl + "/api/rectors/")
            .then((response) => {
                // Rahbariyat shows people. Rector rows created without an
                // employee ("Xodim" empty) are structure-only sections for the
                // "Universitet tuzilmasi" page and must not become a leader card.
                setLeadersData(response.data.filter((leader) => leader.employee && leader.employee.id));
            })
            .catch((error) => {
                console.error("There was an error fetching the staff data!", error);
            });
    }, []);


    return (
        <div className={classes.mainContainer}>
            <div data-aos="fade-up" className={classes["rahbariyat-container"]}>
                <h1 className={classes["page-title"]}>{t("rahbariyat")}</h1>

                {leadersData.length > 0 ? (
                    leadersData.map((leader, index) => {
                        const isRector = index === 0 ||
                            ((leader.position_uz || "").toLowerCase().includes('rektor') && !(leader.position_uz || "").toLowerCase().includes('prorektor')) ||
                            leader.employee?.email === "info-rtu@renessans-edu.uz" ||
                            leader.employee?.id === 1;
                        const bekzodLeader = leadersData.find(l => l.employee && (l.employee.id === 274 || (l.employee.name_uz || '').toLowerCase().includes('bekzod') || (l.employee.name_uz || '').toLowerCase().includes('rozimov')));
                        const bekzodId = bekzodLeader?.employee?.id || 274;
                        const targetEmpId = isRector ? bekzodId : leader.employee?.id;

                        const empName = leader.employee?.[`name_${i18n.language}`] || (isRector ? (bekzodLeader?.employee?.[`name_${i18n.language}`] || '') : '');
                        const empPhone = leader.employee?.phone || (isRector ? bekzodLeader?.employee?.phone : '');
                        const empEmail = leader.employee?.email || (isRector ? bekzodLeader?.employee?.email : '');
                        const empImage = leader.employee?.image || (isRector ? bekzodLeader?.employee?.image : Rektor);
                        const empAbout = leader.employee?.[`about_${i18n.language}`] || (isRector ? bekzodLeader?.employee?.[`about_${i18n.language}`] : '');

                        return (
                            <div
                                className={`${classes.card} ${index === 0 ? classes.highlightedCard : ""
                                    }`}
                                key={leader.id}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    if (targetEmpId) navigate(`/employee/${targetEmpId}`);
                                }}
                            >
                                <div
                                    className={
                                        index === 0 ? classes.headerRight : classes.headerLeft
                                    }
                                >
                                    <div className={classes.info}>
                                        <h2>{empName}</h2>
                                        <p>{leader[`position_${i18n.language}`]}</p>
                                        <div className={classes.contact}>
                                            <div className={classes.contactItem}>
                                                <FaPhoneAlt className={classes.icon} />
                                                <span>{empPhone}</span>
                                            </div>
                                            <div className={classes.contactItem}>
                                                <FaEnvelope className={classes.icon2} />
                                                <span>{empEmail}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Image Section */}
                                    <div className={classes.imageWrapper}>
                                        <img
                                            src={empImage || Rektor}
                                            alt={empName || leader[`position_${i18n.language}`]}
                                            className={classes.logo}
                                        />
                                    </div>
                                </div>

                                {/* Content below the header */}
                                <div className={classes.descriptionSection}>
                                    <div className={classes.descriptionSnippet}>
                                        {(empAbout || "").replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ').replace(/&rsquo;/g, "'").replace(/&lsquo;/g, "'").replace(/&rdquo;/g, '"').replace(/&ldquo;/g, '"').replace(/&ndash;/g, '–').replace(/&mdash;/g, '—').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&apos;/g, "'").substring(0, 250)}...
                                        <span
                                            className={classes.moreBtnLink}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (targetEmpId) navigate(`/employee/${targetEmpId}`);
                                            }}
                                        >
                                            {t("see_more") || "batafsil"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p>{t("loading")}</p>
                )}
            </div>

            <div className={classes.sidebar}>

                <h3>{t("university")}</h3>
                <ul>
                    {universities.map((item, index) => (
                        (index === page_id_test ? (
                            <li className={classes.active} onClick={() => navigate(item.path)}>
                                <span className={classes.icon}>
                                    ▶
                                </span>
                                {t(item.text)}
                            </li>
                        ) : (
                            <li onClick={() => navigate(item.path)}>
                                {t(item.text)}
                            </li>
                        ))
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Rahbariyat;